import { Component } from '@angular/core';
import { NzImageModule, NzImageService } from 'ng-zorro-antd/image';
import { environment } from '../../../../environments/environment';
import { SlideRightDirective } from '../../../directives/animations/slide-right.directive';
import { SlideupDirective } from '../../../directives/animations/slideup.directive';

@Component({
  selector: 'section[app-about-packing-section]',
  imports: [SlideRightDirective, SlideupDirective, NzImageModule],
  templateUrl: './about-packing-section.html',
  styleUrl: './about-packing-section.scss',
})
export class AboutPackingSection {
  constructor(private imageService: NzImageService) {}
  get appname(): string {
    return environment.appname;
  }

  viewImage(src: string): void {
    this.imageService.preview([{ src }]);
  }
}
